import React, { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { config } from 'config';

interface Props {
  clientSecret?: string;
  children: React.ReactNode;
}
const stripePromise = loadStripe(config.STRIPE_PUBLISHABLE_KEY);
export const StripeProvider = ({ clientSecret, children }: Props) => {
  const theme = useTheme() as Theme;

  const appearance = useMemo(
    () => ({
      theme: 'stripe' as 'stripe',
      variables: {
        colorPrimary: theme.colors.blueAccessible,
        colorBackground: '#ffffff',
        colorText: theme.colors.inkPrimary,
        colorDanger: theme.colors.redAccessible,
        fontFamily: theme.fonts.body.fontFamily,
        spacingUnit: `5px`,
        borderRadius: `${theme.borderRadius.std}px`,
      },
    }),
    [theme],
  );

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance,
      }}
    >
      {children}
    </Elements>
  );
};
